import TractorsListContainer from "../../../components/asset-management/TractorsList";

export default function Tractors() {
  return <TractorsListContainer />;
}
